module.exports = __webpack_public_path__ + "img/031.4602ba92.jpg";